export const isValidTelWithHyphen = (value: string) => {
  return value.length >= 12 && value.length <= 13;
};
